export default "__VITE_ASSET__BigDlVJ1__"